import * as React from 'react';
import { cn } from '@/lib/utils';

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(function Input({ className, type = 'text', ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border border-border-strong bg-surface-raised px-3 py-1 text-sm text-ink shadow-sm transition-colors',
        'placeholder:text-ink-subtle disabled:cursor-not-allowed disabled:opacity-50',
        // Invalid fields are marked with aria-invalid; the colour follows it
        // rather than being applied separately, so the two cannot disagree.
        'aria-[invalid=true]:border-danger aria-[invalid=true]:focus-visible:outline-danger',
        className,
      )}
      {...props}
    />
  );
});

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-20 w-full rounded-md border border-border-strong bg-surface-raised px-3 py-2 text-sm text-ink shadow-sm',
        'placeholder:text-ink-subtle disabled:cursor-not-allowed disabled:opacity-50',
        'aria-[invalid=true]:border-danger',
        className,
      )}
      {...props}
    />
  );
});
